export default __webpack_public_path__ + "static/media/icon-question.ff4bda78.svg";